import React from 'react';
import { Link } from 'react-router-dom';
import { useBreadcrumbs } from '../Context/BreadcrumbContext';
import '../CSS/Breadcrumbs.css';

const Breadcrumbs = () => {
    const { trail } = useBreadcrumbs();

    // A lone "Home" crumb says nothing — don't take up the space.
    if (trail.length <= 1) return null;

    return (
        <nav className="crumbs" aria-label="Breadcrumb">
            <ol className="crumbs-list">
                {trail.map((crumb, index) => {
                    const isLast = index === trail.length - 1;

                    return (
                        <React.Fragment key={crumb.key}>
                            {crumb.afterGap && (
                                <li className="crumbs-gap" aria-hidden="true">…</li>
                            )}
                            <li className="crumbs-item">
                                {isLast ? (
                                    <span className="crumbs-current" aria-current="page">
                                        {crumb.label}
                                    </span>
                                ) : (
                                    <Link className="crumbs-link" to={`${crumb.pathname}${crumb.search}`}>
                                        {crumb.label}
                                    </Link>
                                )}
                            </li>
                        </React.Fragment>
                    );
                })}
            </ol>
        </nav>
    );
};

export default Breadcrumbs;
